<template>
  <div class="happening home__section container">
    <div class="happening__title">
      <h2>{{ $t("headers.happening-this-month").toUpperCase() }}</h2>
      <a class="happening__view-all-gigs" :href="gigsUrl">
        {{ $t("buttons.view-all-gigs") }} <i class="fas fa-bars" />
      </a>
    </div>
    <div class="happening-gigs">
      <div
        v-for="(gig, index) in gigsInView"
        :key="index"
        class="happening-gig"
      >
        <a :href="gig.url">
          <img
            v-if="gig.thumbnailUrl"
            class="happening-gig__image"
            :src="gig.thumbnailUrl"
            :alt="gig.title"
          />
          <div v-else class="happening-gig__image-placeholder" />
          <div class="happening-gig__date">
            {{
              `${new Date(gig.startsAt).getDate()} ${
                months[new Date(gig.startsAt).getMonth()]
              }`
            }}
          </div>
          <div class="happening-gig__title"  style="-webkit-box-orient: vertical;">{{ gig.title }}</div>
        </a>
      </div>
    </div>
    <div v-if="gigs.length > 0">
      <div v-if="this.$isDesktop" class="happening-navigation">
        <i
          class="arrow left"
          :class="{ disabled: gigIndex === 3 }"
          @click="
            () => {
              gigIndex > 3 && navigateGigs(-3);
            }
          "
        />
        <i
          class="arrow right"
          :class="{ disabled: gigIndex >= gigs.length }"
          @click="
            () => {
              gigIndex < gigs.length && navigateGigs(3);
            }
          "
        />
      </div>
    </div>
    <div v-else>
      <div class="happening-gig__no-gig-found">
        <h3>No gigs found for this month</h3>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "HappeningComponent",
  props: {
    country: {
      type: String,
      default: "SG",
    },
    months: {
      default: () => [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      type: Array,
    },
    gigsUrl: {
      type: String,
      default: "",
    },
    cache: {
      type: Object,
      default: () => ({
        cache: true,
        component: "happening",
      }),
    },
  },
  apollo: {
    gigs: {
      query: gql`
        query gigsQuery($country: String!) {
          gigs(country: $country) {
            title
            pricing
            genres
            startsAt
            thumbnailUrl
            url
          }
        }
      `,
      variables() {
        return {
          country: this.country,
          cache: this.cache,
        };
      },
      skip() {
        // Without this skip it will sometimes cause blank Firework stories.
        return !this.country;
      },
    },
  },
  data() {
    return {
      gigIndex: 3,
      gigs: [],
    };
  },
  computed: {
    gigsInView() {
      return this.$isMobile
        ? this.gigs
        : this.gigs.slice(this.gigIndex - 3, this.gigIndex + 1);
    },
  },
  methods: {
    navigateGigs(increment) {
      this.gigIndex += increment;
    },
  },
};
</script>
